import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useDbQuery } from '../hooks/useDbQuery';
import { jsx as ___EmotionJSX } from "@emotion/core";

const SEO = ({
  description,
  lang,
  meta,
  keywords,
  title: initialTitle
}) => {
  const db = useDbQuery();
  const title = initialTitle || db.config.title;
  const metaDescription = description || db.config.description;
  return ___EmotionJSX(Helmet, {
    title: title,
    titleTemplate: `%s | ${db.config.title}`,
    htmlAttributes: {
      lang
    },
    meta: [{
      name: `description`,
      content: metaDescription
    }, {
      property: `og:title`,
      content: title
    }, {
      property: `og:description`,
      content: metaDescription
    }, {
      property: `og:type`,
      content: `website`
    }, {
      name: `twitter:card`,
      content: `summary`
    }, {
      name: `twitter:title`,
      content: title
    }, {
      name: `twitter:description`,
      content: metaDescription
    }].concat(keywords.length > 0 ? {
      name: `keywords`,
      content: keywords.join(`, `)
    } : []).concat(meta)
  });
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: []
};
export default SEO;

if (typeof SEO !== 'undefined' && SEO && SEO === Object(SEO) && Object.isExtensible(SEO) && !SEO.hasOwnProperty('__filemeta')) {
  Object.defineProperty(SEO, '__filemeta', {
    configurable: true,
    value: {
      name: "SEO",
      filename: "../../node_modules/gatsby-theme-docz/src/base/Seo.js"
    }
  });
}